/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfContactListItemDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfContactListItemDto } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/contacts
 */
export interface ContactsRequestBuilder extends BaseRequestBuilder<ContactsRequestBuilder> {
    /**
     * Lists every contact in the organization across all of its customers, one row per contact with the customer it belongs to, so a person can be found without first knowing which customer they are attached to. Sort on LastName (the default), FirstName, EmailAddress, CompanyName or ContactType, ascending or descending. The name, email and phone filters match the start of the value; contactType and customerNumber match exactly. Contacts of inactive customers are included and flagged. Contacts are not a resource of their own: to edit or remove one, load its customer, change or drop the contact carrying its contactId, and update the customer.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfContactListItemDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ContactsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfContactListItemDto | undefined>;
    /**
     * Lists every contact in the organization across all of its customers, one row per contact with the customer it belongs to, so a person can be found without first knowing which customer they are attached to. Sort on LastName (the default), FirstName, EmailAddress, CompanyName or ContactType, ascending or descending. The name, email and phone filters match the start of the value; contactType and customerNumber match exactly. Contacts of inactive customers are included and flagged. Contacts are not a resource of their own: to edit or remove one, load its customer, change or drop the contact carrying its contactId, and update the customer.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ContactsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Lists every contact in the organization across all of its customers, one row per contact with the customer it belongs to, so a person can be found without first knowing which customer they are attached to. Sort on LastName (the default), FirstName, EmailAddress, CompanyName or ContactType, ascending or descending. The name, email and phone filters match the start of the value; contactType and customerNumber match exactly. Contacts of inactive customers are included and flagged. Contacts are not a resource of their own: to edit or remove one, load its customer, change or drop the contact carrying its contactId, and update the customer.
 */
export interface ContactsRequestBuilderGetQueryParameters {
    /**
     * Only contacts of this type: Company, Billing, Shipping or Buyer.
     */
    contactType?: string;
    /**
     * Only the contacts of this customer, by customer number.
     */
    customerNumber?: string;
    /**
     * Only contacts whose email address starts with this, ignoring case.
     */
    email?: string;
    /**
     * Only contacts whose last name starts with this, ignoring case.
     */
    name?: string;
    /**
     * The page to return, starting at 1.
     */
    pageNumber?: number;
    /**
     * Contacts per page, at most 100.
     */
    pageSize?: number;
    /**
     * Only contacts whose phone number starts with this.
     */
    phone?: string;
    /**
     * asc (the default) or desc.
     */
    sortDirection?: string;
    /**
     * The column to order by: LastName (the default), FirstName, EmailAddress, CompanyName or ContactType.
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const ContactsRequestBuilderUriTemplate = "{+baseurl}/api/contacts?pageNumber={pageNumber}&pageSize={pageSize}{&contactType*,customerNumber*,email*,name*,phone*,sortDirection*,sortOn*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ContactsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ContactsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfContactListItemDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
